import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Form, FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { minSelectedCheckboxes } from 'src/app/shared/validators/minimumChecked.validator';
import { SettingsService } from '../settings.service';
import { RoleNameValidator } from '../validators/rolenameAsync.validator';
import { RoleSourceValidator } from '../validators/rolesource.validator';
import { KeyValue } from '@angular/common';
import { SharedService } from 'src/app/services/shared.service';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';
import { ToastType } from 'src/app/shared/shared.enums';

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.scss']
})
export class AddRoleComponent implements OnInit, OnDestroy {
  
roleMetaData = {
    "labels" :["Role Name","Assigned Users","Role Description"],
    "placeholder":["Enter role name","User list","Enter role description"],
    "error":{
        "role_name":{
            "required":"Role name is required",
            "roleNameExists":"Role name already exists"
        },
        "role_desc":{
            "required":"Role descripition is required",
        },
        "platforms":{
            "required":"Platform is required",
        },
        "menulist":{
          "required":"Menu is required",
        }
    }
  }
  selectedCustomer:string;
  toasterMessage:string;

  
//   customerwise_role_infos:any
//   customerwise_role_info = {"GS":{"menulist":{"search":{"menu":{"rule":{"disp":"Rule","status":true,"actions":{"Add":{"disp":"Add","cma_id":2,"status":true},"Edit":{"disp":"Edit","cma_id":3,"status":true},"View":{"disp":"View","cma_id":5,"status":true},"Delete":{"disp":"Delete","cma_id":4,"status":true}}},"reports":{"disp":"Reports","status":true,"actions":{"View":{"disp":"View","cma_id":7,"status":true}}},"dashboard":{"disp":"Dashboard","status":true,"actions":{"View":{"disp":"View","cma_id":6,"status":true}}},"explorelogs":{"disp":"Explore logs","status":true,"actions":{"View":{"disp":"View","cma_id":1,"status":true}}}},"category":"Search"},"manage":{"menu":{"role":{"disp":"Role","status":true,"actions":{"Add":{"disp":"Add","cma_id":12,"status":true},"Edit":{"disp":"Edit","cma_id":13,"status":true},"View":{"disp":"View","cma_id":15,"status":true},"Delete":{"disp":"Delete","cma_id":14,"status":true}}},"user":{"disp":"User","status":true,"actions":{"Add":{"disp":"Add","cma_id":8,"status":true},"Edit":{"disp":"Edit","cma_id":9,"status":true},"View":{"disp":"View","cma_id":11,"status":true},"Delete":{"disp":"Delete","cma_id":10,"status":true}}},"studio":{"disp":"Studio","status":true,"actions":{"Add":{"disp":"Add","cma_id":16,"status":true},"Edit":{"disp":"Edit","cma_id":17,"status":true},"View":{"disp":"View","cma_id":19,"status":true},"Delete":{"disp":"Delete","cma_id":18,"status":true}}},"organization":{"disp":"Organization","status":true,"actions":{"View":{"disp":"View","cma_id":20,"status":true}}}},"category":"Manage"},"operate":{"menu":{"deploy":{"disp":"Deploy","status":true,"actions":{"View":{"disp":"View","cma_id":23,"status":true}}},"monitoring":{"disp":"Monitoring","status":true,"actions":{"View":{"disp":"View","cma_id":22,"status":true}}},"fleetmanagement":{"disp":"Fleet Management","status":true,"actions":{"View":{"disp":"View","cma_id":21,"status":true}}}},"category":"Operate"}},"platforms":{"edr":{"disp":"EDR","status":false},"ids":{"disp":"UTM IDS","status":false},"vpn":{"disp":"UTM VPN","status":false},"waf":{"disp":"UTM WAF","status":false},"edlp":{"disp":"EDLP","status":false},"cf_utm":{"disp":"UTM Content Filter","status":false},"windows":{"disp":"Windows","status":false},"antispam":{"disp":"UTM Antispam","status":false},"firewall":{"disp":"Firewall","status":false},"o365_azuread":{"disp":"O365-AzureAD","status":false},"o365_msforms":{"disp":"O365-MSForms","status":false},"o365_msteams":{"disp":"O365-MSTeams","status":false},"o365_exchange":{"disp":"O365-Exchange","status":false},"o365_onedrive":{"disp":"O365-OneDrive","status":false},"o365_sharepoint":{"disp":"O365-SharePoint","status":false},"o365_securitycomp":{"disp":"O365-SecurityComplianceCenter","status":false},"o365_powerplatform":{"disp":"O365-Powerplatform","status":false}},"disp":"Great Soft Pvt ltd"},"tc1":{"menulist":{"manage":{"menu":{"role":{"disp":"Role","status":true,"actions":{"Add":{"disp":"Add","cma_id":104,"status":true},"Edit":{"disp":"Edit","cma_id":105,"status":true},"View":{"disp":"View","cma_id":107,"status":true},"Delete":{"disp":"Delete","cma_id":106,"status":true}}},"user":{"disp":"User","status":true,"actions":{"Add":{"disp":"Add","cma_id":100,"status":true},"Edit":{"disp":"Edit","cma_id":101,"status":true},"View":{"disp":"View","cma_id":103,"status":true},"Delete":{"disp":"Delete","cma_id":102,"status":true}}},"studio":{"disp":"Studio","status":true,"actions":{"Add":{"disp":"Add","cma_id":108,"status":true},"Edit":{"disp":"Edit","cma_id":109,"status":true},"View":{"disp":"View","cma_id":111,"status":true},"Delete":{"disp":"Delete","cma_id":110,"status":true}}},"organization":{"disp":"Organization","status":true,"actions":{"View":{"disp":"View","cma_id":115,"status":true}}}},"category":"Manage"},"operate":{"menu":{"deploy":{"disp":"Deploy","status":true,"actions":{"View":{"disp":"View","cma_id":114,"status":true}}},"monitoring":{"disp":"Monitoring","status":true,"actions":{"View":{"disp":"View","cma_id":113,"status":true}}},"fleetmanagement":{"disp":"Fleet Management","status":true,"actions":{"View":{"disp":"View","cma_id":112,"status":true}}}},"category":"Operate"},"search":{"menu":{"rule":{"disp":"Rule","status":true,"actions":{"Add":{"disp":"Add","cma_id":94,"status":true},"Edit":{"disp":"Edit","cma_id":95,"status":true},"View":{"disp":"View","cma_id":97,"status":true},"Delete":{"disp":"Delete","cma_id":96,"status":true}}},"reports":{"disp":"Reports","status":true,"actions":{"View":{"disp":"View","cma_id":99,"status":true}}},"dashboard":{"disp":"Dashboard","status":true,"actions":{"View":{"disp":"View","cma_id":98,"status":true}}},"explorelogs":{"disp":"Explore logs","status":true,"actions":{"View":{"disp":"View","cma_id":93,"status":true}}}},"category":"Search"}},"platforms":{"edr":{"disp":"EDR","status":false},"waf":{"disp":"UTM WAF","status":false},"edlp":{"disp":"EDLP","status":false},"windows":{"disp":"Windows","status":false},"antispam":{"disp":"UTM Antispam","status":false},"firewall":{"disp":"Firewall","status":false},"o365_exchange":{"disp":"O365-Exchange","status":false}},"disp":"test_customer1"},"tc2":{"menulist":{"manage":{"menu":{"role":{"disp":"Role","status":true,"actions":{"Add":{"disp":"Add","cma_id":127,"status":true},"Edit":{"disp":"Edit","cma_id":128,"status":true},"View":{"disp":"View","cma_id":130,"status":true},"Delete":{"disp":"Delete","cma_id":129,"status":true}}},"user":{"disp":"User","status":true,"actions":{"Add":{"disp":"Add","cma_id":123,"status":true},"Edit":{"disp":"Edit","cma_id":124,"status":true},"View":{"disp":"View","cma_id":126,"status":true},"Delete":{"disp":"Delete","cma_id":125,"status":true}}},"studio":{"disp":"Studio","status":true,"actions":{"Add":{"disp":"Add","cma_id":131,"status":true},"Edit":{"disp":"Edit","cma_id":132,"status":true},"View":{"disp":"View","cma_id":134,"status":true},"Delete":{"disp":"Delete","cma_id":133,"status":true}}},"organization":{"disp":"Organization","status":true,"actions":{"View":{"disp":"View","cma_id":138,"status":true}}}},"category":"Manage"},"search":{"menu":{"rule":{"disp":"Rule","status":true,"actions":{"Add":{"disp":"Add","cma_id":117,"status":true},"Edit":{"disp":"Edit","cma_id":118,"status":true},"View":{"disp":"View","cma_id":120,"status":true},"Delete":{"disp":"Delete","cma_id":119,"status":true}}},"reports":{"disp":"Reports","status":true,"actions":{"View":{"disp":"View","cma_id":122,"status":true}}},"dashboard":{"disp":"Dashboard","status":true,"actions":{"View":{"disp":"View","cma_id":121,"status":true}}},"explorelogs":{"disp":"Explore logs","status":true,"actions":{"View":{"disp":"View","cma_id":116,"status":true}}}},"category":"Search"},"operate":{"menu":{"deploy":{"disp":"Deploy","status":true,"actions":{"View":{"disp":"View","cma_id":137,"status":true}}},"monitoring":{"disp":"Monitoring","status":true,"actions":{"View":{"disp":"View","cma_id":136,"status":true}}},"fleetmanagement":{"disp":"Fleet Management","status":true,"actions":{"View":{"disp":"View","cma_id":135,"status":true}}}},"category":"Operate"}},"platforms":{"edr":{"disp":"EDR","status":false},"waf":{"disp":"UTM WAF","status":false},"edlp":{"disp":"EDLP","status":false},"windows":{"disp":"Windows","status":false},"antispam":{"disp":"UTM Antispam","status":false},"firewall":{"disp":"Firewall","status":false},"o365_exchange":{"disp":"O365-Exchange","status":false}},"disp":"test_customer2"},"tc4":{"menulist":{"search":{"menu":{"rule":{"disp":"Rule","status":true,"actions":{"Add":{"disp":"Add","cma_id":163,"status":true},"Edit":{"disp":"Edit","cma_id":164,"status":true},"View":{"disp":"View","cma_id":166,"status":true},"Delete":{"disp":"Delete","cma_id":165,"status":true}}},"reports":{"disp":"Reports","status":true,"actions":{"View":{"disp":"View","cma_id":168,"status":true}}},"dashboard":{"disp":"Dashboard","status":true,"actions":{"View":{"disp":"View","cma_id":167,"status":true}}},"explorelogs":{"disp":"Explore logs","status":true,"actions":{"View":{"disp":"View","cma_id":162,"status":true}}}},"category":"Search"},"operate":{"menu":{"deploy":{"disp":"Deploy","status":true,"actions":{"View":{"disp":"View","cma_id":183,"status":true}}},"monitoring":{"disp":"Monitoring","status":true,"actions":{"View":{"disp":"View","cma_id":182,"status":true}}},"fleetmanagement":{"disp":"Fleet Management","status":true,"actions":{"View":{"disp":"View","cma_id":181,"status":true}}}},"category":"Operate"},"manage":{"menu":{"role":{"disp":"Role","status":true,"actions":{"Add":{"disp":"Add","cma_id":173,"status":true},"Edit":{"disp":"Edit","cma_id":174,"status":true},"View":{"disp":"View","cma_id":176,"status":true},"Delete":{"disp":"Delete","cma_id":175,"status":true}}},"user":{"disp":"User","status":true,"actions":{"Add":{"disp":"Add","cma_id":169,"status":true},"Edit":{"disp":"Edit","cma_id":170,"status":true},"View":{"disp":"View","cma_id":172,"status":true},"Delete":{"disp":"Delete","cma_id":171,"status":true}}},"studio":{"disp":"Studio","status":true,"actions":{"Add":{"disp":"Add","cma_id":177,"status":true},"Edit":{"disp":"Edit","cma_id":178,"status":true},"View":{"disp":"View","cma_id":180,"status":true},"Delete":{"disp":"Delete","cma_id":179,"status":true}}},"organization":{"disp":"Organization","status":true,"actions":{"View":{"disp":"View","cma_id":184,"status":true}}}},"category":"Manage"}},"platforms":{"windows":{"disp":"Windows","status":false},"firewall":{"disp":"Firewall","status":false},"o365_exchange":{"disp":"O365-Exchange","status":false}},"disp":"testcustomer4"},"tc5":{"menulist":{"search":{"menu":{"rule":{"disp":"Rule","status":true,"actions":{"Add":{"disp":"Add","cma_id":186,"status":true},"Edit":{"disp":"Edit","cma_id":187,"status":true},"View":{"disp":"View","cma_id":189,"status":true},"Delete":{"disp":"Delete","cma_id":188,"status":true}}},"reports":{"disp":"Reports","status":true,"actions":{"View":{"disp":"View","cma_id":191,"status":true}}},"dashboard":{"disp":"Dashboard","status":true,"actions":{"View":{"disp":"View","cma_id":190,"status":true}}},"explorelogs":{"disp":"Explore logs","status":true,"actions":{"View":{"disp":"View","cma_id":185,"status":true}}}},"category":"Search"},"operate":{"menu":{"deploy":{"disp":"Deploy","status":true,"actions":{"View":{"disp":"View","cma_id":206,"status":true}}},"monitoring":{"disp":"Monitoring","status":true,"actions":{"View":{"disp":"View","cma_id":205,"status":true}}},"fleetmanagement":{"disp":"Fleet Management","status":true,"actions":{"View":{"disp":"View","cma_id":204,"status":true}}}},"category":"Operate"},"manage":{"menu":{"role":{"disp":"Role","status":true,"actions":{"Add":{"disp":"Add","cma_id":196,"status":true},"Edit":{"disp":"Edit","cma_id":197,"status":true},"View":{"disp":"View","cma_id":199,"status":true},"Delete":{"disp":"Delete","cma_id":198,"status":true}}},"user":{"disp":"User","status":true,"actions":{"Add":{"disp":"Add","cma_id":192,"status":true},"Edit":{"disp":"Edit","cma_id":193,"status":true},"View":{"disp":"View","cma_id":195,"status":true},"Delete":{"disp":"Delete","cma_id":194,"status":true}}},"studio":{"disp":"Studio","status":true,"actions":{"Add":{"disp":"Add","cma_id":200,"status":true},"Edit":{"disp":"Edit","cma_id":201,"status":true},"View":{"disp":"View","cma_id":203,"status":true},"Delete":{"disp":"Delete","cma_id":202,"status":true}}},"organization":{"disp":"Organization","status":true,"actions":{"View":{"disp":"View","cma_id":207,"status":true}}}},"category":"Manage"}},"platforms":{"windows":{"disp":"Windows","status":false},"firewall":{"disp":"Firewall","status":false},"o365_exchange":{"disp":"O365-Exchange","status":false}},"disp":"testcustomer5"},"tc6":{"menulist":{"operate":{"menu":{"deploy":{"disp":"Deploy","status":true,"actions":{"View":{"disp":"View","cma_id":229,"status":true}}},"monitoring":{"disp":"Monitoring","status":true,"actions":{"View":{"disp":"View","cma_id":228,"status":true}}},"fleetmanagement":{"disp":"Fleet Management","status":true,"actions":{"View":{"disp":"View","cma_id":227,"status":true}}}},"category":"Operate"},"search":{"menu":{"rule":{"disp":"Rule","status":true,"actions":{"Add":{"disp":"Add","cma_id":209,"status":true},"Edit":{"disp":"Edit","cma_id":210,"status":true},"View":{"disp":"View","cma_id":212,"status":true},"Delete":{"disp":"Delete","cma_id":211,"status":true}}},"reports":{"disp":"Reports","status":true,"actions":{"View":{"disp":"View","cma_id":214,"status":true}}},"dashboard":{"disp":"Dashboard","status":true,"actions":{"View":{"disp":"View","cma_id":213,"status":true}}},"explorelogs":{"disp":"Explore logs","status":true,"actions":{"View":{"disp":"View","cma_id":208,"status":true}}}},"category":"Search"},"manage":{"menu":{"role":{"disp":"Role","status":true,"actions":{"Add":{"disp":"Add","cma_id":219,"status":true},"Edit":{"disp":"Edit","cma_id":220,"status":true},"View":{"disp":"View","cma_id":222,"status":true},"Delete":{"disp":"Delete","cma_id":221,"status":true}}},"user":{"disp":"User","status":true,"actions":{"Add":{"disp":"Add","cma_id":215,"status":true},"Edit":{"disp":"Edit","cma_id":216,"status":true},"View":{"disp":"View","cma_id":218,"status":true},"Delete":{"disp":"Delete","cma_id":217,"status":true}}},"studio":{"disp":"Studio","status":true,"actions":{"Add":{"disp":"Add","cma_id":223,"status":true},"Edit":{"disp":"Edit","cma_id":224,"status":true},"View":{"disp":"View","cma_id":226,"status":true},"Delete":{"disp":"Delete","cma_id":225,"status":true}}},"organization":{"disp":"Organization","status":true,"actions":{"View":{"disp":"View","cma_id":230,"status":true}}}},"category":"Manage"}},"platforms":{"edr":{"disp":"EDR","status":false},"windows":{"disp":"Windows","status":false},"firewall":{"disp":"Firewall","status":false},"o365_exchange":{"disp":"O365-Exchange","status":false}},"disp":"testcustomer6"},"tc7":{"menulist":{"operate":{"menu":{"deploy":{"disp":"Deploy","status":true,"actions":{"View":{"disp":"View","cma_id":252,"status":true}}},"monitoring":{"disp":"Monitoring","status":true,"actions":{"View":{"disp":"View","cma_id":251,"status":true}}},"fleetmanagement":{"disp":"Fleet Management","status":true,"actions":{"View":{"disp":"View","cma_id":250,"status":true}}}},"category":"Operate"},"search":{"menu":{"rule":{"disp":"Rule","status":true,"actions":{"Add":{"disp":"Add","cma_id":232,"status":true},"Edit":{"disp":"Edit","cma_id":233,"status":true},"View":{"disp":"View","cma_id":235,"status":true},"Delete":{"disp":"Delete","cma_id":234,"status":true}}},"reports":{"disp":"Reports","status":true,"actions":{"View":{"disp":"View","cma_id":237,"status":true}}},"dashboard":{"disp":"Dashboard","status":true,"actions":{"View":{"disp":"View","cma_id":236,"status":true}}},"explorelogs":{"disp":"Explore logs","status":true,"actions":{"View":{"disp":"View","cma_id":231,"status":true}}}},"category":"Search"},"manage":{"menu":{"role":{"disp":"Role","status":true,"actions":{"Add":{"disp":"Add","cma_id":242,"status":true},"Edit":{"disp":"Edit","cma_id":243,"status":true},"View":{"disp":"View","cma_id":245,"status":true},"Delete":{"disp":"Delete","cma_id":244,"status":true}}},"user":{"disp":"User","status":true,"actions":{"Add":{"disp":"Add","cma_id":238,"status":true},"Edit":{"disp":"Edit","cma_id":239,"status":true},"View":{"disp":"View","cma_id":241,"status":true},"Delete":{"disp":"Delete","cma_id":240,"status":true}}},"studio":{"disp":"Studio","status":true,"actions":{"Add":{"disp":"Add","cma_id":246,"status":true},"Edit":{"disp":"Edit","cma_id":247,"status":true},"View":{"disp":"View","cma_id":249,"status":true},"Delete":{"disp":"Delete","cma_id":248,"status":true}}},"organization":{"disp":"Organization","status":true,"actions":{"View":{"disp":"View","cma_id":253,"status":true}}}},"category":"Manage"}},"platforms":{"windows":{"disp":"Windows","status":false},"firewall":{"disp":"Firewall","status":false},"o365_exchange":{"disp":"O365-Exchange","status":false}},"disp":"testcustomer7"},"tc8":{"menulist":{"manage":{"menu":{"role":{"disp":"Role","status":true,"actions":{"Add":{"disp":"Add","cma_id":265,"status":true},"Edit":{"disp":"Edit","cma_id":266,"status":true},"View":{"disp":"View","cma_id":268,"status":true},"Delete":{"disp":"Delete","cma_id":267,"status":true}}},"user":{"disp":"User","status":true,"actions":{"Add":{"disp":"Add","cma_id":261,"status":true},"Edit":{"disp":"Edit","cma_id":262,"status":true},"View":{"disp":"View","cma_id":264,"status":true},"Delete":{"disp":"Delete","cma_id":263,"status":true}}},"studio":{"disp":"Studio","status":true,"actions":{"Add":{"disp":"Add","cma_id":269,"status":true},"Edit":{"disp":"Edit","cma_id":270,"status":true},"View":{"disp":"View","cma_id":272,"status":true},"Delete":{"disp":"Delete","cma_id":271,"status":true}}},"organization":{"disp":"Organization","status":true,"actions":{"View":{"disp":"View","cma_id":276,"status":true}}}},"category":"Manage"},"operate":{"menu":{"deploy":{"disp":"Deploy","status":true,"actions":{"View":{"disp":"View","cma_id":275,"status":true}}},"monitoring":{"disp":"Monitoring","status":true,"actions":{"View":{"disp":"View","cma_id":274,"status":true}}},"fleetmanagement":{"disp":"Fleet Management","status":true,"actions":{"View":{"disp":"View","cma_id":273,"status":true}}}},"category":"Operate"},"search":{"menu":{"rule":{"disp":"Rule","status":true,"actions":{"Add":{"disp":"Add","cma_id":255,"status":true},"Edit":{"disp":"Edit","cma_id":256,"status":true},"View":{"disp":"View","cma_id":258,"status":true},"Delete":{"disp":"Delete","cma_id":257,"status":true}}},"reports":{"disp":"Reports","status":true,"actions":{"View":{"disp":"View","cma_id":260,"status":true}}},"dashboard":{"disp":"Dashboard","status":true,"actions":{"View":{"disp":"View","cma_id":259,"status":true}}},"explorelogs":{"disp":"Explore logs","status":true,"actions":{"View":{"disp":"View","cma_id":254,"status":true}}}},"category":"Search"}},"platforms":{"windows":{"disp":"Windows","status":false},"firewall":{"disp":"Firewall","status":false}},"disp":"testcustomer8"}}
    //  customerwise_role_infos:any;
  customerwise_role_infos:any
  
  selectedCustomerData:any = {}

//   roleMetaData = this._service.metaData.settings.addeditrole;
  // sourceList = this._service.metaData.commonData.platformOptions.platformList;
  // showSettingsmenu: boolean = false
  // showErrors: boolean = false
  // inputBoxEmitChar = this._service.metaData.commonData.specialCharList.charList;
  submitState:boolean = false;
  platformErrorState:boolean =false;
  mat_spinner_role_state: boolean
  platformValueChanges: boolean=false
  roleDescValueChanges: boolean=false
  assignUserValueChanges: boolean=false

  $destroy: Subject<boolean> = new Subject()
  addRoleForm:FormGroup

  platfromValueChangesSubscription: Subscription;
  menuValueChangesSubscription:Subscription;
  menuValueChanges:boolean=false;
  // label = ["Search", "Manage", "Operate"]

  service_provider_name:string
  customerUiInputCollection:any ={} 
  previousCutomerinitialPlatformValue:any
  previousCutomerinitialmenuValue:any

  val:FormGroup

  //injecting mat-dialog, settingservice and formbuilder

  constructor(private ref: MatDialogRef<AddRoleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private settingsService: SettingsService,
    private fb: UntypedFormBuilder,
    private sharedService: SharedService,
    private toastService: ToastService
    ) {
  }

  ngOnInit(): void {
    this.patchvalue_check()
//console.log("useerlist check",this.data.userlist)

    this.customerwise_role_infos = this.data.customerlist
    this.selectedCustomer = this.data.defultcustomer
    this.service_provider_name = this.data.service_provider
    if(this.data.editdata){
        this.addRoleForm = this.fb.group({
            role_name: ['', [Validators.required]],
            assigned_user: new UntypedFormControl(),
            role_desc: ['', [Validators.required]],
        })
        this.data.selectedUser = this.data.selectedUser?this.data.selectedUser:[]
        this.role_name.disable();
        this.role_name.setValue(this.data.roleinfo.role_name)
        this.role_desc.setValue(this.data.roleinfo.role_desc)
        this.assigned_user.patchValue(this.data.selectedUser)
        this.role_desc.valueChanges.subscribe(val=>{
          // console.log("role_desc changes =====",val)
          if(val != this.data.roleinfo.role_desc){
            this.roleDescValueChanges = true
            // this.addRoleForm.valid = true
            this.platforms.setErrors(null)
          }
          else{
            this.roleDescValueChanges = false
          }
        })

        this.assigned_user.valueChanges.subscribe(val=>{
          // console.log("assigned_user changes =====",val,JSON.stringify(this.data.selectedUser) ,JSON.stringify(val),JSON.stringify(this.data.selectedUser) != JSON.stringify(val))
          if( JSON.stringify(this.data.selectedUser) != JSON.stringify(val)){
            this.assignUserValueChanges = true
            // this.addRoleForm.valid = true
            this.platforms.setErrors(null)
          }
          else{
            this.assignUserValueChanges = false
          }
        })
        
    }
    else{
        this.addRoleForm = this.fb.group({
            role_name: ['', [Validators.required],[RoleNameValidator.createValidator(this.settingsService)]],
            assigned_user: new UntypedFormControl(),
            role_desc: ['', [Validators.required]],
          })
    }
    
    for(let custName in this.customerwise_role_infos){
        let isselected = false
        for(let platform in this.customerwise_role_infos[custName]["platforms"]){
            if(this.customerwise_role_infos[custName]["platforms"][platform]["status"]){
                isselected = true
                break
            }
        }
        if(isselected){
            this.setPlatformContol(custName)
            this.setMenuControl(custName)

            this.customerwise_role_infos[custName]["already_checked"] = true
            this.customerwise_role_infos[custName]["isselected"] = true

            if(this.customerUiInputCollection.hasOwnProperty(custName)){
              this.customerUiInputCollection[custName]["platforms"] = this.platforms.value
              this.customerUiInputCollection[custName]["menulist"] = this.menulist.value
            }
            else{
              this.customerUiInputCollection[custName] = {}
              this.customerUiInputCollection[custName]["platforms"] = this.platforms.value
              this.customerUiInputCollection[custName]["menulist"] = this.menulist.value
            }

            this.addRoleForm.removeControl('platforms')
            this.addRoleForm.removeControl('menulist')
        }
        else{
            this.customerwise_role_infos[custName]["already_checked"] = false
            this.customerwise_role_infos[custName]["isselected"] = false
            for(let category in this.customerwise_role_infos[custName]["menulist"]){
              for(let menu in this.customerwise_role_infos[custName]["menulist"][category]['menu']){
                this.customerwise_role_infos[custName]["menulist"][category]['menu'][menu]['status']=true
              }
            }
        }
    }
   
    
    this.setPlatformContol(this.selectedCustomer)
    this.setMenuControl(this.selectedCustomer)
    this.subscribeToValueChanges();
  }



  patchvalue_check(){
    this.val = this.fb.group({
        red:['', [Validators.required]],
        blue:['', [Validators.required]]
    })

    this.val.patchValue({"red":true,"blue":false})

    // console.log("patchvalue_check======",this.val.controls)
  }

  get red(){
    return this.val.get('red')
  }

  get role_name(){
    return this.addRoleForm.get('role_name')
  }

  get assigned_user(){
    return this.addRoleForm.get('assigned_user')
  }

  get role_desc(){
    return this.addRoleForm.get('role_desc')
  }

  get platforms(){
    return this.addRoleForm.get("platforms") as FormGroup
  }

  get menulist(){
    return this.addRoleForm.get("menulist") as FormGroup
  }

  subscribeToValueChanges(){
    this.platfromValueChangesSubscription = this.platforms.valueChanges.subscribe(value => {
        this.platformValueChanges = true
    });

    this.menuValueChangesSubscription = this.menulist.valueChanges.subscribe(value => {
      if(this.customerUiInputCollection.hasOwnProperty(this.selectedCustomer)){
        this.menuValueChanges = true
        this.platforms.setErrors(null)
      }
      // console.log("menuValueChangesSubscription===================",value)

  });
  }

  controlUnsubscribe() {
    // Unsubscribe from the existing subscription
    if (this.platfromValueChangesSubscription) {
      this.platfromValueChangesSubscription.unsubscribe();
    }

    if (this.menuValueChangesSubscription) {
      this.menuValueChangesSubscription.unsubscribe();
    }
    
  }

  getMenucategoryControl(menuCategroy:string){
    return this.menulist.get(menuCategroy) as FormGroup
  }

  getMenuControl(menuCategroy:string,item:string){
    return this.getMenucategoryControl(menuCategroy).get(item) as FormGroup
  }

  getActionControl(menuCategroy:string,item:string){
    return this.getMenuControl(menuCategroy,item).get('actions') as FormGroup
  }


  close() {
    this.ref.close()
  }



  submitRole_click() {
    this.submitState = true
    this.checkPreviousControlDirty()
    this.updatePreviousCustomerChanges()
    if(this.menuValueChanges){
      this.platforms.setErrors(null)
    }
    // console.log("this.addRoleForm.valid============",this.addRoleForm.valid)
    if(this.addRoleForm.valid || this.roleDescValueChanges || this.assignUserValueChanges){
        let roleNewPostReq = this.addRoleForm.value
        roleNewPostReq["created_by"] = this.sharedService.userName
        roleNewPostReq.assigned_user = roleNewPostReq.assigned_user?roleNewPostReq.assigned_user:[]
        roleNewPostReq["customers"] = {}
        
        // console.log(this.customerUiInputCollection)
        for (let customer in this.customerUiInputCollection){
            let selectedPlatform = false
          // if(this.data.editdata){
            let customerPlatformValue = this.customerUiInputCollection[customer]["platforms"]
            for(let item in customerPlatformValue){
              // console.log(item,customerPlatformValue[item])
              if(customerPlatformValue[item]){
                selectedPlatform = true
                // break
              }
            }
//console.log("selectedPlatform====",customer,selectedPlatform)
            if(!selectedPlatform){
              delete this.customerUiInputCollection[customer]
            }
          // }
        }
        // console.log("roleNewPostReq=====",this.customerUiInputCollection)
        for (let customer in this.customerUiInputCollection){
          // if(selectedPlatform){
            roleNewPostReq["customers"][customer] = {}
            roleNewPostReq["customers"][customer]["disp"] = this.customerwise_role_infos[customer]["disp"]
            roleNewPostReq["customers"][customer]["platforms"] = this.customerwise_role_infos[customer]["platforms"]
            
            let cma_ids = []
            let customerMenuValue = this.customerUiInputCollection[customer]["menulist"]
            // console.log("customer_data===============",customerMenuValue)
            for (let category in customerMenuValue){
                for(let menuCategroy in customerMenuValue[category]){
                    for(let menuaction in customerMenuValue[category][menuCategroy]){
                        if(menuaction != "actions"){
                            if(customerMenuValue[category][menuCategroy][menuaction] && this.customerwise_role_infos[customer]["menulist"][category]["menu"].hasOwnProperty(menuaction)){
                                // console.log(category,menuaction,this.customerwise_role_infos[customer]["menulist"][category]["menu"])
                                for (let action in this.customerwise_role_infos[customer]["menulist"][category]["menu"][menuaction]["actions"]){
                                    // console.log(category,menuaction,action,this.customerwise_role_infos[customer]["menulist"],customer,this.customerwise_role_infos,this.customerwise_role_infos[this.selectedCustomer]["menulist"][category]["menu"][menuaction])
                                    cma_ids.push(this.customerwise_role_infos[customer]["menulist"][category]["menu"][menuaction]["actions"][action]["cma_id"])
                                }
                            }
                        }
                    }
                }
            }
            roleNewPostReq["customers"][customer]["cma_ids"] = cma_ids
//console.log("customer===>",customer,cma_ids)
          // }
        }
        delete roleNewPostReq["platforms"]
        delete roleNewPostReq["menulist"]
//console.log("roleNewPostReq=====",roleNewPostReq)
        
            this.platformErrorState = false
            if(!this.data.editdata){
              if (Object.getOwnPropertyNames(roleNewPostReq["customers"]).length === 0 || !this.platformValueChanges) {
                  this.platforms.setErrors({customError:true})
                  this.platformErrorState = true
                  // console.log("this.platforms.errors?.customError======",this.platforms.errors?.customError)
              } else {
                this.settingsService.postNewRole(roleNewPostReq)
                .pipe(takeUntil(this.$destroy))
                .toPromise()
                .then((result:any) => {
                if(result.status != 1){
                  
                  this.toasterMessage = "New role post failed"
                  this.toastService.ShowToaster(this.toasterMessage, ToastType.failure)
                }
                else{
                  this.toasterMessage = "New role successfuly post"
                  this.toastService.ShowToaster(this.toasterMessage, ToastType.success)
                }
                this.mat_spinner_role_state = false
                this.submitState = false
                
                this.ref.close(result)
              })
              .catch((err)=>{
                this.mat_spinner_role_state = false
                this.submitState = false
                // this.toasterMessage = "New role post failed"
                // this.settingsService.showToaster(this.toasterMessage, 'failure')
                this.ref.close({"status":0})
              })
              }
            }
            else{
              // console.log(Object.getOwnPropertyNames(roleNewPostReq["customers"]).length === 0 , !this.platformValueChanges, !this.roleDescValueChanges)
              if ((Object.getOwnPropertyNames(roleNewPostReq["customers"]).length === 0 || !this.platformValueChanges ) && !this.roleDescValueChanges && !this.assignUserValueChanges && !this.menuValueChanges) {
                  // if(!this.platformValueChanges){

                  // }
                  this.platforms.setErrors({customError:true})
                  this.platformErrorState = true
                  // console.log("this.platforms.errors?.customError======",this.platforms.errors?.customError)
              } else {

                let editedObj = {
                    "role_id": this.data.roleinfo.role_id,
                    "role_name":this.data.roleinfo.role_name,
                    "role_desc":this.role_desc.value,
                    "roledescchange":this.roleDescValueChanges,
                    "assigned_user":this.assigned_user.value,
                    "assigneduserchange":this.assignUserValueChanges,
                    "created_by":this.sharedService.userName,
                    "customers":roleNewPostReq["customers"]
                }

                // console.log("editedObj=====",editedObj)
                this.settingsService.postRoleedit(editedObj)
                .pipe(takeUntil(this.$destroy))
                .toPromise()
                .then((result:any) => {
                    if(result.status != 1){
                      
                      this.toasterMessage = "Edit role post failed"
                      this.toastService.ShowToaster(this.toasterMessage, ToastType.failure)
                    }
                    else{
                      this.toasterMessage = "Edit role successfuly post"
                      this.toastService.ShowToaster(this.toasterMessage, ToastType.success)
                    }
                    this.mat_spinner_role_state = false
                    this.submitState = false
                    
                    this.ref.close(result)
                  })
                  .catch((err)=>{
                    this.mat_spinner_role_state = false
                    this.submitState = false
                    // this.toasterMessage = "Edit role post failed"
                    // this.settingsService.showToaster(this.toasterMessage, 'failure')
                    this.ref.close({"status":0})
                  })
                }
            }
        // }
        
    }
   
  }
  //unsort the key value from the array of objects
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }
  cancel() {
    this.ref.close()
  }
  getActionClassname(action){
    return "checkmark-lite-"+action
  }

  setPlatformContol(customerName:string){
    this.addRoleForm.addControl('platforms',new FormGroup({}))
    this.selectedCustomerData = this.customerwise_role_infos[customerName]
    let platfromData = this.selectedCustomerData['platforms']
    for(let item in platfromData){
        this.platforms.addControl(item,new FormControl(platfromData[item]['status']))
        if(platfromData[item]['status']){
            this.customerwise_role_infos[customerName]["isselected"] = true
        }
    }
    this.previousCutomerinitialPlatformValue = this.platforms.value
    if(this.data.editdata && this.customerwise_role_infos[customerName]["already_checked"]){
      if(this.customerUiInputCollection.hasOwnProperty(this.selectedCustomer)){
        this.customerUiInputCollection[this.selectedCustomer]["platforms"] = this.previousCutomerinitialPlatformValue
        }
        else{
            this.customerUiInputCollection[this.selectedCustomer] = {}
            this.customerUiInputCollection[this.selectedCustomer]["platforms"] = this.previousCutomerinitialPlatformValue
        }

    }
    
  }
  setMenuControl(customerName:string){
    this.addRoleForm.addControl('menulist',new FormGroup({}))
    let menuData = this.selectedCustomerData['menulist']
    for(let menucategory in menuData){
        this.menulist.addControl(menucategory,new FormGroup({}))
        for (let menuval in menuData[menucategory]["menu"]){
            this.getMenucategoryControl(menucategory).addControl(menucategory+"~"+menuval,new FormGroup({}))
            this.getMenuControl(menucategory,menucategory+"~"+menuval).addControl(menuval,new FormControl(menuData[menucategory]["menu"][menuval]['status']))
            this.getMenuControl(menucategory,menucategory+"~"+menuval).addControl('actions',new FormGroup({}))
            for (let action in menuData[menucategory]["menu"][menuval]["actions"]){
                let menustatus = menuData[menucategory]["menu"][menuval]['status']
                // console.log(action,menuData[menucategory]["menu"][menuval]['actions'][action].status)
                // this.getActionControl(menucategory,menucategory+"~"+menuval).addControl(action,new FormControl({'value':menustatus?menuData[menucategory]["menu"][menuval]['actions'][action].status:false,disabled:menustatus?false:true}))
                this.getActionControl(menucategory,menucategory+"~"+menuval).addControl(action,new FormControl({'value':menustatus?true:false,disabled:menustatus?false:true}))

            }
            this.getMenuControl(menucategory,menucategory+"~"+menuval).get("actions").disable()
        }
    }
    this.previousCutomerinitialmenuValue = this.menulist.value
    if(this.data.editdata && this.customerwise_role_infos[customerName]["already_checked"]){
      if(this.customerUiInputCollection.hasOwnProperty(this.selectedCustomer)){
        this.customerUiInputCollection[this.selectedCustomer]["menulist"] = this.previousCutomerinitialmenuValue
        }
        else{
            this.customerUiInputCollection[this.selectedCustomer] = {}
            this.customerUiInputCollection[this.selectedCustomer]["menulist"] = this.previousCutomerinitialmenuValue
        }

    }
  }

  getActionDisp(menuCategroy:string,item:string,itemkey:string){
    return this.selectedCustomerData.menulist[menuCategroy]['menu'][item.split('~')[1]]['actions'][itemkey].disp
  }


  updatePreviousCustomerChanges(){
    // previous customer platform changes update
    // console.log("updatePreviousCustomerChanges=====",this.selectedCustomer,this.platforms,this.menulist)
    
        let previousCutomerPlatformValue = this.platforms.value
        for(let val in previousCutomerPlatformValue){
            this.customerwise_role_infos[this.selectedCustomer]["platforms"][val]["status"]=previousCutomerPlatformValue[val]
        }

    if(this.platforms.dirty||this.menulist.dirty || this.customerwise_role_infos[this.selectedCustomer]["already_checked"]){
      
      
      // if(this.platforms.dirty){

        if(this.customerUiInputCollection.hasOwnProperty(this.selectedCustomer)){
            this.customerUiInputCollection[this.selectedCustomer]["platforms"] = previousCutomerPlatformValue
            this.customerUiInputCollection[this.selectedCustomer]["menulist"] = this.menulist.value
        }
        else{
            this.customerUiInputCollection[this.selectedCustomer] = {}
            this.customerUiInputCollection[this.selectedCustomer]["platforms"] = previousCutomerPlatformValue
            this.customerUiInputCollection[this.selectedCustomer]["menulist"] = this.menulist.value
        }
    }
    
    if(this.menulist.dirty){
        let previousCutomerMenuValue = this.menulist.value 
        for(let category in previousCutomerMenuValue){
            for(let menuCategroy in previousCutomerMenuValue[category]){
                for(let menuaction in previousCutomerMenuValue[category][menuCategroy]){
                    if(menuaction != "actions"){
                        this.customerwise_role_infos[this.selectedCustomer]["menulist"][category]["menu"][menuaction]["status"]=previousCutomerMenuValue[category][menuCategroy][menuaction]
                        for (let action in previousCutomerMenuValue[category][menuCategroy]["actions"]){
                            this.customerwise_role_infos[this.selectedCustomer]["menulist"][category]["menu"][menuaction]["actions"][action]["status"] = previousCutomerMenuValue[category][menuCategroy]["actions"][action]
                        }
                    }
                }
            }

        }
    }
  }

  checkPreviousControlDirty(){
    let platfromstate = false
    let menustate = false
    let previousCutomercurrentPlatformValue = this.platforms.value
    let previousCutomercurrentMenuValue = this.menulist.value
    // if(!this.customerwise_role_infos[this.selectedCustomer]["already_checked"]){
        for(let val in previousCutomercurrentPlatformValue){
            if(previousCutomercurrentPlatformValue[val]){
                platfromstate = true
                break
            }
        }
        
        if(!platfromstate){
            this.customerwise_role_infos[this.selectedCustomer]["isselected"] = false
            this.platforms.markAsPristine()
            this.platforms.markAsUntouched()
            delete this.customerUiInputCollection[this.selectedCustomer]
        }
        else{
            this.customerwise_role_infos[this.selectedCustomer]["isselected"] = true
        }

        
    // }
    // else{
    //     for(let val in previousCutomercurrentPlatformValue){
    //         if(previousCutomercurrentPlatformValue[val]){
    //             platfromstate = true
    //             break
    //         }
    //     }
    
    //     if(!platfromstate){
    //         this.customerwise_role_infos[this.selectedCustomer]["isselected"] = false
    //         this.platforms.markAsPristine()
    //         this.platforms.markAsUntouched()
    //         delete this.customerUiInputCollection[this.selectedCustomer]
    //     }
    //     else{
    //         this.customerwise_role_infos[this.selectedCustomer]["isselected"] = true
    //     }
    // }
    

    // for(let val in previousCutomercurrentMenuValue){
    //     if(previousCutomercurrentMenuValue[val]){
    //         menustate = true
    //         break
    //     }
    // }
  }
  changeCutsomerClick(index:number,customer_info:any,event:Event){
        this.checkPreviousControlDirty()
        // console.log("changeCutsomerClick===>",this.platforms,this.menulist,this.menulist.value)
        this.updatePreviousCustomerChanges()

        // Next customer 
        this.selectedCustomer = customer_info.key
        this.addRoleForm.removeControl('platforms')
        this.setPlatformContol(customer_info.key)
        

        this.addRoleForm.removeControl('menulist')
        this.setMenuControl(customer_info.key)
        this.subscribeToValueChanges();
    
  }

  menuActionToggleControl(menuKeyControl:string,categoryKeyContol:string){
    let actionscontrolObj = this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions')
    let actionKeys = Object.keys(actionscontrolObj.value)
    let menuKeyControlvalue = this.getMenuControl(menuKeyControl,categoryKeyContol).get(categoryKeyContol.split('~')[1]).value?false:true
    this.getMenuControl(menuKeyControl,categoryKeyContol).get(categoryKeyContol.split('~')[1]).setValue(menuKeyControlvalue)
    if(menuKeyControlvalue){
        this.getActionControl(menuKeyControl,categoryKeyContol).enable()
        this.getActionControl(menuKeyControl,categoryKeyContol).get('view').setValue(true)
        // print()
        let previousMenuActionValue = this.customerwise_role_infos[this.selectedCustomer]["menulist"][menuKeyControl]["menu"][categoryKeyContol.split('~')[1]]["actions"]
        actionKeys.forEach((action)=>{
            // this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').get(action).setValue(previousMenuActionValue[action]["status"])
            this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').get(action).setValue(true)

        })
        this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').disable()
    }
    else{
        
        actionKeys.forEach((action)=>{
            this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').get(action).setValue(false)
        })
        this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').disable()
    }    
    let menuvalues = this.menulist.value
    let menuChange = false
    for( let category in menuvalues ){
      for (let category_menu in menuvalues[category] ){
        for (let menu in menuvalues[category][category_menu] ){
          // console.log(category,category_menu,menu,menuvalues[category][category_menu][menu])
          if(menuvalues[category][category_menu][menu]){
            menuChange  = true
            break
          }
        }
      }
    }

    if(!menuChange){
      this.getMenuControl(menuKeyControl,categoryKeyContol).get(categoryKeyContol.split('~')[1]).setValue(true)
      this.getActionControl(menuKeyControl,categoryKeyContol).enable()
      this.getActionControl(menuKeyControl,categoryKeyContol).get('view').setValue(true)
        // print()
        let previousMenuActionValue = this.customerwise_role_infos[this.selectedCustomer]["menulist"][menuKeyControl]["menu"][categoryKeyContol.split('~')[1]]["actions"]
        actionKeys.forEach((action)=>{
            // this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').get(action).setValue(previousMenuActionValue[action]["status"])
            this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').get(action).setValue(true)

        })
        this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').disable()
    }
  }

  actionToggleControl(actionKeyControl:string,menuKeyControl:string,categoryKeyContol:string){
    if(actionKeyControl.toLowerCase() == 'view'){
        let actionKeyControlvalue = this.getActionControl(menuKeyControl,categoryKeyContol).get('view').value?false:true
        if(!actionKeyControlvalue){
            this.getMenuControl(menuKeyControl,categoryKeyContol).get(categoryKeyContol.split('~')[1]).setValue(false)
            let actionscontrolObj = this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions')
            let actionKeys = Object.keys(actionscontrolObj.value)
            actionKeys.forEach((action)=>{
                this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').get(action).setValue(false)
            })
            this.getMenuControl(menuKeyControl,categoryKeyContol).get('actions').disable()
        }
    }
  }
  ngOnDestroy(): void {
    if (this.platfromValueChangesSubscription) {
      this.platfromValueChangesSubscription.unsubscribe();
    }
    if (this.menuValueChangesSubscription) {
      this.menuValueChangesSubscription.unsubscribe();
    }
    this.$destroy.next(true)
  }

}







// import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
// import { Form, FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { Subject } from 'rxjs';
// import { takeUntil } from 'rxjs/operators';
// import { minSelectedCheckboxes } from 'src/app/shared/validators/minimumChecked.validator';
// import { UserLoginService } from 'src/app/user-login/user-login.service';
// import { SettingsService } from '../settings.service';
// import { RoleNameValidator } from '../validators/rolenameAsync.validator';
// import { RoleSourceValidator } from '../validators/rolesource.validator';

// @Component({
//   selector: 'app-add-role',
//   templateUrl: './add-role.component.html',
//   styleUrls: ['./add-role.component.scss']
// })
// export class AddRoleComponent implements OnInit, OnDestroy {

//   roleMetaData = this._service.metaData.settings.addeditrole;
//   sourceList = this._service.metaData.commonData.platformOptions.platformList;
//   showSettingsmenu: boolean = false
//   showErrors: boolean = false
//   inputBoxEmitChar = this._service.metaData.commonData.specialCharList.charList;
//   mat_spinner_role_state: boolean
//   $destroy: Subject<boolean> = new Subject()
//   label = ["Search", "Manage", "Operate"]


//   //injecting mat-dialog, settingservice and formbuilder

//   constructor(private ref: MatDialogRef<AddRoleComponent>,
//     @Inject(MAT_DIALOG_DATA) public data: any,
//     private settingService: SettingsService,
//     private fb: UntypedFormBuilder,
//     private _service: UserLoginService) {
//   }


//   addRoleForm = this.fb.group({
//     role_name: ['', [Validators.required], [RoleNameValidator.createValidator(this.settingService)]],
//     product: new UntypedFormControl(),
//     source: new UntypedFormControl([], RoleSourceValidator()),
//     assigned_user: new UntypedFormControl(),
//     menu_list: new FormGroup({
//     }, { validators: [minSelectedCheckboxes()] })
//   })

//   ngOnInit(): void {
//     this.addCheckboxes();
//     if (this.data.editdata) {
//       console.log(this.data.editdata)
//       this.setformValues(this.data.editdata);
//       this.roleName.clearAsyncValidators();

//     } else {
//       this.product.setValue('SIEM');
//     }
//     this.product.disable();
//   }


//   setformValues(editdata: any) {
//     this.addRoleForm.patchValue(editdata);
//     editdata.menu_list.forEach((menu: string) => {
//       this.menu_list.get(menu).setValue(true);
//     })
//   }

//   addCheckboxes() {
//     this.data.menulist.forEach((category: any) => {
//       category.menu.forEach((menu: any) => {
//         this.menu_list.addControl(menu.menu_id, new FormControl(false));
//       })
//     })
//   }

//   //returning formcontrols and formArray from the form group on their respective names.

//   get menu_list() {
//     return this.addRoleForm.get('menu_list') as FormGroup;
//   }

//   get roleName() {
//     return this.addRoleForm.get('role_name')
//   }

//   get users() {
//     return this.addRoleForm.get('assigned_user')
//   }

//   get source() {
//     return this.addRoleForm.get('source')
//   }

//   get product() {
//     return this.addRoleForm.get('product')
//   }
//   //closes mat-dialog.

//   close() {
//     this.ref.close()
//   }

//   getMenuList(menu_obj: any) {
//     const menu_arr = [];
//     for (let menu in menu_obj) {
//       if (menu_obj[menu]) {
//         menu_arr.push(menu);
//       }
//     }
//     return menu_arr;
//   }

//   /*Submit method checks if the form is valid. If it's invalid it triggres and shows the error messages for 
//   each formControl. Also, calls the post method and sends the newly created roleObj as a body when the form is valid.*/

//   submitRole_click() {
//     if (this.addRoleForm.valid) {
//       this.mat_spinner_role_state = true;
//       var newRoleObject = {
//         role_name: this.roleName.value,
//         product: this.product.value,
//         menu_authorized: this.getMenuList(this.menu_list.value),
//         modified_dt: new Date(),
//         created_by: this._service.userName,
//         source: this.source.value,
//         assigned_user: this.users.value
//       }
//       if (!this.data.editdata) {
//         this.settingService.postNewrole(newRoleObject)
//           .pipe(takeUntil(this.$destroy))
//           .subscribe((val) => {
//             this.mat_spinner_role_state = false;
//             this.ref.close(val);
//             this.settingService.showToaster(this.roleMetaData.result.success, 'success');
//           }, (err) => {
//             this.mat_spinner_role_state = false;
//             // this.settingService.showToaster('Role post failed', 'failure');
//           })
//       }
//       if (this.data.editdata) {
//         var newRoleClone = { ...newRoleObject }
//         let editedMiniObj = {
//           created_by: this.data.editdata.created_by,
//           role_id: this.data.editdata.role_id,
//           role_type: this.data.editdata.role_type
//         }
//         let editedObj = { ...newRoleClone, ...editedMiniObj }
//         this.settingService.postRoleedit(editedObj)
//           .pipe(takeUntil(this.$destroy))
//           .subscribe(val => {
//             this.mat_spinner_role_state = false;
//             this.ref.close(val)
//             this.settingService.showToaster(this.roleMetaData.result.changes, 'success');

//           }, (err) => {
//             this.mat_spinner_role_state = false;
//             // this.settingService.showToaster('Role post failed', 'failure')
//           })
//       }
//     } else {
//       this.showErrors = true;
//     }
//   }

//   cancel() {
//     this.ref.close()
//   }

//   ngOnDestroy(): void {
//     this.$destroy.next(true)
//   }

// }
